import styles from './ChangeRegMode.module.css'
import ModalWindow from "../../../FormTemplate/ModalWindow/ModalWindow";
import MainFormTemplate from "../../../FormTemplate/MainFormTemplate/MainFormTemplate";
import ErrorLineItem, {ErrorLineItemRef} from "../../../FormTemplate/ErrorLineItem/ErrorLineItem";
import ButtonContainer from "../../../FormTemplate/ButtonContainer/ButtonContainer";
import React, {useRef, useState} from "react";
import SelectUnit, {SelectUnitDataInt, SelectUnitRefInt} from "../../../FormTemplate/SelectUnit/SelectUnit";
import useApiQuery from "../../../ApiQuery/UseApiQuery";
interface IChangeRegModeProps
{
    orderId:string
    onClose:()=>void
    onSuccess:()=>void
}

interface IRegModeUpdate
{
    orderId:string
    regMode:number
}

export default function ChangeRegMode({ orderId,onClose,onSuccess}:IChangeRegModeProps){
    const refState = useRef<ErrorLineItemRef>(null)
    const refModeList =useRef<SelectUnitRefInt>(null)


    const dataRegMode = useRef<IRegModeUpdate>()
    const [ldrRegModeUpdate,rsRegModeUpdate,exRegModeUpdate] = useApiQuery("/sell/sim/order/regmode/change","post",dataRegMode);


    const [newMode, setNewMode] = useState(-1)
    const [modeList] = useState<SelectUnitDataInt[]>([
        {
          name: "Обычный",
          val: 0,
        },
        {
            name: "Перенос [ MNP ]",
            val: 10,
        },
        {
            name: "Саморегистрация",
            val: 1,
        },


    ])


    const handleUpdate = ()=>{
        if(refState?.current)refState?.current.clear()
        if(newMode < 0 ){
            if(refState?.current)refState?.current?.show("Не выбран тип заказа", true,5000)
            return
        }

        dataRegMode.current = {
            orderId: orderId,
            regMode: newMode
        }
        exRegModeUpdate().then((e)=>{
            if(e?.success){
                if(refState.current)refState.current.show("Данные обновлены",false,0)
                if(onSuccess)onSuccess()
                return

            }
            if(refState.current)refState.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера",true,5000)

        })


    }



    return(
        <ModalWindow cssClass={styles.mdMain}>
            <MainFormTemplate title={`Смена типа заказа [ ${orderId} ]`} maxWidth={"600px"} background={"white"} load={ldrRegModeUpdate}>
                <div className={"row"}>
                    <div className={"col-lg-12"}>
                        <div className={styles.suCont}>
                            <SelectUnit ref={refModeList} inData={modeList} capt={"Тип заказа"} multiSelect={false} getVal={(e)=>{
                                //if(e.length   === 0) return
                                if(e?.length) setNewMode(Number(e[0]))


                            }}/>
                        </div>
                    </div>
                </div>
                <div className={"row my-2"}>
                    <ErrorLineItem ref={refState} height={"30px"}/>
                </div>

                <div className={"row my-2"}>
                    <div className={"d-flex col-12"}>
                        <ButtonContainer clsCont={styles.btnCont}>
                            <button type="button" className="btn btn-secondary "
                                    onClick={handleUpdate}
                            >Обновить</button>

                            <button type="button" className="btn btn-secondary "
                                    onClick={onClose}
                            >Выход</button>


                        </ButtonContainer>

                    </div>

                </div>

            </MainFormTemplate>
        </ModalWindow>
    )
}